<template>
  <div >
    <el-form :model="userInfo" :rules="rules" ref="userInfo" class="infoForm">
        <el-form-item class="infoInput" prop="personName">
           <el-input v-model="userInfo.personName" placeholder="姓名" :disabled="userInfo.personNameStatus" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item class="infoInput" prop="personNo">
            <el-input v-model="userInfo.personNo" placeholder="学工号" :disabled="userInfo.personNoStatus"  maxlength="25"></el-input>
        </el-form-item>
        <el-form-item class="infoInput">
             <el-input v-model="userInfo.identityNo" placeholder="身份证号"  maxlength="25"></el-input>
        </el-form-item>

        <el-form-item class="infoBtn">
            <el-button type="primary" @click="getIdentity('userInfo')">验证身份</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {checkName,checkCode,checkStudentId} from '../../../config/formCheck'
  import SendCode from '../../../public/sendCode'
export default {
  name: "infoForm",
    components: {
      sendCode:SendCode
    },
  data() {
    return {
      userInfo: {
        personName: "",
        personNo: "",
        personNoStatus:"",
        personNameStatus:"",
        identityNo: "",
        token:"",
        phoneNo:""
      },
      codeInfo:{
          errorMsg:""
        },
       rules: {
          personName: [
            { validator: checkName, trigger: 'change' }
          ],
          personNo: [
            { validator: checkStudentId, trigger: 'change' }
          ]
        },
    };
  },
  mounted(){
    const personNo = sessionStorage.getItem("officeEmail_personNo")
    const name = sessionStorage.getItem("officeEmail_name")
    if(personNo !=""){
      this.userInfo.personNo = personNo;
      this.userInfo.personNoStatus = true;
    }else{
      this.userInfo.personNoStatus = false;
    }
    if(name !=""){
      this.userInfo.personName = name;
      this.userInfo.personNameStatus = true;
    }else{
      this.userInfo.personNameStatus = false;
    }
  },
  methods: {
      //验证身份
      getIdentity(userInfo){
        let self = this
         self.$refs[userInfo].validate((valid) => {
          if (valid) {
             const loading = self.$loading({
                  lock: true,
                  text: '正在验证中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                self.codeInfo.errorMsg =""
                const personName = self.userInfo.personName
                const identityNo = self.userInfo.identityNo
                const personNo = self.userInfo.personNo
                const phoneNo = sessionStorage.getItem("officeEmail_phoneNo")
                const token = self.md5(sessionStorage.getItem("officeEmail_token"))
                const url = '/email/regiterInfo?personName='+personName+
                '&identityNo='+identityNo+'&phoneNo='+phoneNo+'&personNo='+personNo+'&token='+token
                self.postRequest(url,{}).then((result)=>{
                    console.log("验证身份：",result.data)
                    loading.close();
                    if(result.data){
                      if(result.data.msgStatus == 1){
                          const _data = JSON.parse(result.data.data)
                          sessionStorage.setItem("officeEmail_token",result.data.msgCode)
                          sessionStorage.setItem("officeEmail_userInfo",JSON.stringify(_data.data))
                        if(_data.data.sids.indexOf(",") == "-1"){
                          self.$router.push({ name: 'RegOfficialEmail'})
                        }else{
                          self.$router.push({ name: 'UserInfo'})
                        }
                      }else if(result.data.msgStatus == 2){
                          self.codeInfo.errorMsg = result.data.msgCode
                      }else if( result.data.msgStatus == 3 ){
                        self.$alert("校友邮箱已注册", '错误提示', {
                          confirmButtonText: '确定',
                          dangerouslyUseHTMLString: true,
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }else if(result.data.msgStatus == 4){
                          //self.$alert("学校邮箱未注册，请先 <a href='http://mail-mgmt-test.tongji.edu.cn:9000/oiosaml/saml/login' style='color:#198bfd;text-decoration:underline;'>注册学校邮箱</a>", '错误提示', {
                          self.$alert("学校邮箱未注册，请先 <a href='http://mail-mgmt.tongji.edu.cn:9000/oiosaml/saml/login' style='color:#198bfd;text-decoration:underline;'>注册学校邮箱</a>", '错误提示', {
                          confirmButtonText: '确定',
                          dangerouslyUseHTMLString: true,
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }else if( result.data.msgStatus == 5 ){
                        self.$alert('你输入的信息不正确，请核实', '错误提示', {
                          confirmButtonText: '确定',
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }else if( result.data.msgStatus == 6 ){
                        self.$confirm("手机号未录入系统，更新手机号？", '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                        }).then(() => {
                          self.$router.push({ name: 'UpdatePhone'})
                        }).catch(() => {
                          self.$message({
                            type: 'info',
                            message: '已取消操作'
                          });
                        });
                      }else if( result.data.msgStatus == 8 ){
                        self.$alert("用户信息不存在，请先前往</br><a href='http://www.tongjiren.org/front/login/reg' style='color:#198bfd;text-decoration:underline;'>校友会平台</a>认证", '错误提示', {
                          confirmButtonText: '确定',
                          type: 'error',
                          dangerouslyUseHTMLString: true,
                          center: true,
                          customClass:'errMessage'
                        });
                      }else{
                        self.$alert("系统错误，请稍后再试", '错误提示', {
                          confirmButtonText: '确定',
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }
                  }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        //
      },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.infoForm {
  margin-top: 38px;
}
.infoInput {
  width: 308px;
  height: 41px;
  margin: 0 auto;
  margin-top: 18px;
}
  .infoBtn{
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
  }
  .infoBtn button{
    width: 310px;
  }
</style>



// WEBPACK FOOTER //
// src/page/officialEmail/checkIdentity/infoForm.vue